#import "@/apollo/fragments/ClientUploadConfig.gql"

query ClientUploadConfig($clientId: ID!) {
    client(id: $clientId) {
        _id
        ...ClientUploadConfig
    }
}
